<template>
  <div class="policyInformation">
    <el-row>
      <!-- 面包屑 -->
      <el-col :span="24"
        ><Breadcrumbs :arr="['碳汇管理平台', '用户管理']"
      /></el-col>
      <!-- 查询表单 -->
      <el-col class="search" :span="24">
        <el-form :inline="true" :model="search" class="demo-form-inline">
          <el-form-item label="姓名">
            <el-input
              size="small"
              v-model="search.name"
              maxlength="100"
              clearable
              placeholder="请输入"
              class="inline-input"
            ></el-input>
          </el-form-item>

           <el-form-item label="手机号码">
            <el-input
              size="small"
              v-model="search.phone"
              maxlength="100"
              clearable
              placeholder="请输入"
              class="inline-input"
            ></el-input>
          </el-form-item>

          <!-- <el-form-item label="角色名称">
            <el-select
              v-model="search.type"
              clearable
              placeholder="请选择"
              size="small"
            >
              <el-option label="政策信息发布" :value="0"> </el-option>
              <el-option label="工作推进成果" :value="1"> </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item class="btn">
            <!-- class="theme-btn" -->
            <el-button size="small" type="primary" @click="getList" round
              >查询</el-button
            >
            <el-button
              size="small"
              style="margin: 0 0 0 50px"
              @click="reset"
              round
              type="info"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>
      <!-- 表格数据 -->
      <el-col class="main_table" :span="24">
        <div class="table_btn">
          <!-- class="theme-btn" -->
          <el-button size="small" type="primary" @click="isAddData" round
            >新增用户</el-button
          >
        </div>
        <Tables
          class="table"
          :columns="columns"
          :loading="loading"
          :tableData="tableData"
        >
          <template #type="scope">
            <el-switch
                v-model="scope.row.enabled"
                @change="isEnable(scope.row.id, scope.row)"
                active-color="#13ce66"
              >
            </el-switch>
          </template>
          <template #actions="scope">
            <div class="flex">
              <el-button type="text" @click="isEdit(scope.row)"
                >修改</el-button
              >
              <el-button type="text" @click="isDelete(scope.row.id)"
                >删除</el-button
              >
              <el-button type="text" @click="resetPassword(scope.row.id)"
                >重置密码</el-button
              >
            </div>
          </template>
        </Tables>
        <Paginations :pageData="pageData" :sizeChange="sizeChange" :currentChange="currentChange" />
      </el-col>
    </el-row>
    <modaDialogl
      :dialog="dialog"
      :formData="formData"
      :handleClose="handleClose"
      :isView="isShowView"
      :isPassword="isPassword"
    />
  </div>
</template>
<script>
import {
  getCarbonSinkUserList,
  delCarbonSinkUse,
} from "@/api/api";
import Breadcrumbs from "@/components/breadcrumbs/breadcrumbs.vue";
import Tables from "@/components/tables/tables.vue";
import modaDialogl from "./components/modaDialogl.vue";
import Paginations from "@/components/paginations/paginations.vue";
import { columns } from "./js/columns";
export default {
  name: "policyInformation",
  data() {
    return {
      search: {
        "name": "",
	      "phone": ""
      },
      pickerOptionsYear: {
        disabledDate: (time) => {
          const start = Date.parse(this.search.startYear);
          const end = Date.parse(this.search.endYear);
          if (this.search.endYear) {
            return time.getTime() > Date.now() || time.getTime() > end;
          } else {
            return time.getTime() > Date.now();
          }
        },
      },
      pickerOptionsYear1: {
          disabledDate: (time) => {
            const start = Date.parse(this.search.startYear);
            const end = Date.parse(this.search.endYear);
            if (this.search.startYear) {
              return (
                time.getTime() < start - 8.64e7
              );
            } else {
              // return time.getTime() > Date.now();
            }
          },
      },
      // 表格展示数据
      tableData: [],
      // 表格显示标题
      columns: [],
      loading: false,
      // 弹出框设置
      dialog: {
        size: 720,
        visible: false,
        title: "新增",
      },
      // 分页
      pageData: {
        size: 10,
        page: 1,
        total: 0,
      },
      // 是否显示操作按钮
      isShowView: true,
      // 用户信息
      userInfo: {},
      // 表单信息
      formData: {},
      // 是否是修改密码
      isPassword:false,
    };
  },
  methods: {
    // 页面初始化
    init() {
      this.columns = columns;
      this.getList();
    },
    // 获取数据列表
    getList() {
      let page = {
        current: this.pageData.page,
        size: this.pageData.size,
      };
      this.loading = true
      getCarbonSinkUserList(this.search, page).then((res) => {
        if (res.data.code == "200") {
          this.tableData = res.data.data.records;
          this.pageData.total = res.data.data.total;
        }
        this.loading = false
      });
    },
    // 点击重置
    reset() {
      this.search = {
        "name": "",
	      "phone": "",
      };
      this.getList();
    },
    // 关闭弹出框
    handleClose() {
      this.dialog.visible = false;
    },
    // 新增
    isAddData() {
      this.formData = {
        loginName: "", // 用户名
        name: "", // 姓名
        password: "", // 密码
        phone: "", // 手机号
        sex:'', // 性别
        isFirstlevel:0,
        isTwolevel:0,
      };
      this.isPassword = false
      this.dialog.visible = true;
      this.isShowView = true;
      this.dialog.title = "新增";
    },
    // 修改
    isEdit(row) {
      this.formData = {...row};
      this.dialog.visible = true;
      this.dialog.title = "修改";
      this.isShowView = true;
      this.isPassword = false
    },
    // 详情
    resetPassword(id) {
      this.formData = {
        id:id,
        password:''
      };
      this.isPassword = true
      this.dialog.visible = true;
      this.dialog.title = "重置密码";
      this.isShowView = true;
    },
    // 删除
    isDelete(id) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delCarbonSinkUse(id).then((res) => {
            console.log(res);
            if (res.data.code == 200) {
              if (this.tableData.length == 1) {
                let page = this.pageData.page - 1;
                page = page <= 0 ? 0 : page;
                this.pageData.page = page;
              }
              this.getList();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //禁用启用
    isEnable(e, row) {
      row.enabled = row.enabled == true ? "1" : "0";
      // editUser(row).then((res) => {
      //   if (res.data.code === "200") {
      //     if (row.enabled == 0) this.$message.success("禁用成功");
      //     if (row.enabled == 1) this.$message.success("启用成功");
      //     this.data.tableData.find((item) => item.id == e).enabled =
      //       row.enabled == 1 ? true : false;
      //   } else {
      //     this.$message.error(res.data.message);
      //     this.data.tableData.find((item) => item.id == e).enabled =
      //       !row.enabled;
      //   }
      // });
    },
    // 通过类型返回文字
    changeType(type){
        if(type==0) return '政策信息发布'
        else if(type==1) return '工作推进成果'
        else return ''
    },
    // 切换条数
    sizeChange(val){
        this.pageData.size = val
        this.getList()
    },
    // 切换页数
    currentChange(val){
        this.pageData.page = val
        this.getList()
    },
    setUrl(arr){
      arr = JSON.parse(arr)
      if(arr.length)
        return arr[0].url
      else return ''
    },
  },
  mounted() {
    this.init();
  },
  components: {
    Breadcrumbs,
    Tables,
    modaDialogl,
    Paginations,
  },
};
</script>
<style scoped>
.flex {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.operation{
  color: #409EFF;
}
</style>
